<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  total: number | null | undefined
  peak: number | null | undefined
  offpeak: number | null | undefined
}>()

const hasCost = computed(() => props.total !== null && props.total !== undefined)

function money(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—'
  return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
</script>

<template>
  <div v-if="hasCost">
    <h4 class="mb-2 text-xs font-semibold uppercase tracking-wide text-primary">Custo de energia</h4>
    <div class="grid grid-cols-2 gap-3 md:grid-cols-4">
      <!-- Total: destaque, ocupa mais espaço e texto maior -->
      <div class="col-span-2 border-2 border-primary bg-primary/5 px-4 py-3">
        <p class="text-[11px] font-semibold uppercase tracking-wide text-primary">Custo total</p>
        <p class="mt-0.5 whitespace-nowrap leading-tight">
          <span class="text-base font-semibold text-primary/70">R$</span>
          <span class="text-3xl font-extrabold text-primary"> {{ money(total) }}</span>
        </p>
      </div>

      <!-- Ponta -->
      <div class="border border-amber-300 bg-amber-50 px-3 py-2">
        <p class="text-[10px] font-medium uppercase tracking-wide text-amber-700">Custo ponta</p>
        <p class="mt-0.5 whitespace-nowrap leading-tight">
          <span class="text-xs font-semibold text-amber-600">R$</span>
          <span class="text-xl font-bold text-amber-700"> {{ money(peak) }}</span>
        </p>
      </div>

      <!-- Fora ponta -->
      <div class="border border-stroke bg-white px-3 py-2">
        <p class="text-[10px] font-medium uppercase tracking-wide text-slate-500">Custo fora ponta</p>
        <p class="mt-0.5 whitespace-nowrap leading-tight">
          <span class="text-xs font-semibold text-slate-400">R$</span>
          <span class="text-xl font-bold text-slate-900"> {{ money(offpeak) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
